import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)); }, []);
  const cats = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const filtered = cat === "All" ? items : items.filter((i) => i.category === cat);
  return (
    <div data-testid="gallery-page">
      <section className="hero-bg py-12">
        <div className="container-x">
          <span className="font-cursive text-2xl text-brand-green">Gallery</span>
          <h1 className="text-4xl sm:text-5xl font-bold">Inside One Hospitals</h1>
        </div>
      </section>
      <section className="container-x py-10">
        <div className="flex flex-wrap gap-2 mb-8">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)}
              className={`px-4 py-1.5 text-sm rounded-full border ${cat === c ? "bg-brand-purple text-white border-brand-purple" : "bg-white border-slate-200 text-slate-700"}`}
              data-testid={`gallery-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}>{c}</button>
          ))}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filtered.map((g) => (
            <div key={g.id} className="relative rounded-2xl overflow-hidden group" data-testid={`gallery-${g.id}`}>
              <img src={g.image} alt={g.title} className="w-full h-56 object-cover group-hover:scale-105 transition" />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4 text-white">
                <div className="font-semibold">{g.title}</div>
                <div className="text-xs opacity-80">{g.category}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
